<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="ukategoriTanimlama"> Urun Kategori Tanımlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="ukategoriList"> Urun Kategori List
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="ukategoriDetay"> Urun Kategori Detay
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="ukategoriGuncelle"> Urun  Kategori Güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="urunKategoriKaldir"> Urun Kategori Kaldır
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="urunTanimlama"> Urun Tanımlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="urunKategoriAtama"> Urun Kategori Atama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="urunGuncelle"> Urun Güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="kategoriUrunList">Kategori  Urun Listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="urunListesi">Urun Listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="urunDetay"> Urun Detay
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="urunDurumGuncelle"> Urun Durum Güncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="uopsiyonTanimlama"> Urun Opsiyon Tanımlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="uopsiyonList"> Urun Opsiyon List
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="uopsiyonDetay"> Urun Opsiyon Detay
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="uopsiyonGuncelle"> Urun Opsiyon Guncelle
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="uopsiyonKaldir"> Urun Opsiyon Kaldır
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import urunService from '../../../WSProvider/UrunService';
    import notification from '../../../notification'
    let base64 = require('base64_js');
    let userData = "";
    export default {
        name: "UrunDetay",
        methods: {
            urunTanimlama() {
                let dil = [{
                    dil: "en",
                    baslik: "fbdb",
                    altBaslik: "fddb",
                    icerik: "gbhgfnbfg",
                    seoBaslik: "ghnfg",
                    seoIcerik: "fghn"
                }];
                urunService.urunTanimlama("dv", "gbgfn", "gfnfgn","fbfgn","50.00","hkjhk","dfhg",[],1,dil,["UK-73000"],[]);
            },
            urunDurumGuncelle() {
                urunService.urunDurumGuncelle("SRT-73006", 0);
            },
            urunDetay() {
                urunService.urunDetay("SRT-73006");
            },
            urunGuncelle() {
                let updateList = [{
                    type: "baslik",
                    value: "nesnensnes"
                }];
                urunService.urunGuncelle("SRT-73006", updateList);
            },
            ukategoriTanimlama() {
                urunService.ukategoriTanimlama("", "dgdsf","dfjgfdb","nbjbjhb","fgjnghk",[],"",1,[
                    {
                        en: [{
                            baslik: "dfsdf",
                            altBaslik: "dfdsf",
                            icerik: "dsffs",
                            seoBaslik:" dsfsdfdsf",
                            seoIcerik:"dfdsfgsd"
                        }]
                    }
                ])
            },
            ukategoriList() {
                urunService.ukategoriList(1, "");
            },
            ukategoriDetay() {
                urunService.ukategoriDetay("UK-73000");
            },
            ukategoriGuncelle() {
                let updateList = [{
                    type: "baslik",
                    value: "nesnessb"
                }];
                urunService.ukategoriGuncelle("UK-73000", updateList);
            },
            urunKategoriKaldir() {
                urunService.urunKategoriKaldir("UK-73000");
            },
            urunKategoriAtama() {
                urunService.urunKategoriAtama(1, 0,10);
            },
            urunListesi() {
                urunService.urunListesi(1, 0,10);
            },
            kategoriUrunList() {
                urunService.kategoriUrunList("UK-73000", "");
            },
            uopsiyonTanimlama() {

                urunService.uopsiyonTanimlama("hfghfh", 1,1,1,[],["UK-73000"]);
            },
            uopsiyonList() {
                urunService.uopsiyonList(0,0,1);
            },
            uopsiyonDetay() {
                urunService.uopsiyonDetay("UO-73003");
            },
            uopsiyonGuncelle() {
                let updateList = [{
                    type: "baslik",
                    value: "nesnessb"
                }];
                urunService.uopsiyonGuncelle("UO-73003", updateList);
            },
            uopsiyonKaldir() {
                urunService.uopsiyonKaldir("UO-73003");
            },

        }
    }
</script>

<style scoped>

</style>